import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { SettingsBox } from 'src/Elements/Data'
import { NumberField } from 'src/Libs/inputs/react-hook-form'
import { DynamicTariffSettingsFormFields } from 'src/Libs/dynamic-tariff-settings/constants'
import { UnitTypes } from 'src/Libs/types'
import { useApp } from 'src/Hooks'

interface Props {
  hasWritingRights: boolean
}

/**
 * Component to add static grid fee settings for dynamic tariff settings form
 */
const StaticGridFeeSettingsForm: React.FC<Props> = ({ hasWritingRights }) => {
  const { t } = useCustomTranslation()
  const { isMobile: isDownSm } = useApp()
  const suffix = (
    <NumberField
      disabled={!hasWritingRights}
      sx={{ ...(isDownSm ? { width: '100%' } : { maxWidth: theme => theme.spacing(25) }) }}
      name={DynamicTariffSettingsFormFields.GridFees}
      suffix={UnitTypes.centsPerKiloWattHour}
      inputProps={{ style: { textAlign: 'right' } }}
    />
  )
  return <SettingsBox title={t('dynamic-tariff-settings.static-grid-fee.title')} suffix={suffix} disabled={!hasWritingRights} />
}

export default StaticGridFeeSettingsForm
